(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nifty-lab-home-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('pointermove', function (event) {
    var target = event.target;
    var board = target && target.closest ? target.closest('[data-nh-glow]') : null;
    if (!board) return;
    var box = board.getBoundingClientRect();
    board.style.setProperty('--mx', Math.round(event.clientX - box.left) + 'px');
    board.style.setProperty('--my', Math.round(event.clientY - box.top) + 'px');
  }, { passive: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nifty-lab-product-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('nifty-lab-page')) return;
    class NiftyLabPage extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        const q = (s) => this.querySelector(s);
        const qa = (s) => Array.from(this.querySelectorAll(s));
        const mainImg = q('.nl-hero-img');
        const show = (src, alt) => {
          if (!mainImg || !src) return;
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = src;
          if (alt) mainImg.alt = alt;
          qa('.nl-tile').forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.src === src)));
        };
        qa('.nl-tile').forEach((t) => t.addEventListener('click', () => show(t.dataset.src, t.dataset.alt)));
        const more = q('[data-showall]');
        if (more) more.addEventListener('click', () => {
          qa('.nl-more').forEach((t) => { t.hidden = false; });
          more.hidden = true;
        });

        const idInput = q('[data-variant-id]');
        const pills = qa('.nl-pill');
        pills.forEach((p) => p.addEventListener('click', () => {
          const ok = p.dataset.available === 'true';
          pills.forEach((x) => x.setAttribute('aria-pressed', String(x === p)));
          if (idInput) idInput.value = p.dataset.variant;
          const name = q('[data-variant-name]');
          if (name) name.textContent = p.dataset.title;
          qa('b[data-price]').forEach((el) => { el.textContent = p.dataset.price; });
          const cmp = q('[data-compare]');
          if (cmp) { cmp.hidden = p.dataset.onsale !== 'true'; cmp.textContent = p.dataset.compare; }
          qa('[data-add]').forEach((b) => { b.disabled = !ok; });
          qa('[data-add-label]').forEach((el) => { el.textContent = ok ? 'Add to cart' : 'Sold out'; });
          const inc = q('.nl-incl');
          const incText = q('[data-incl-text]');
          if (inc && incText) { incText.textContent = p.dataset.incl || ''; inc.hidden = !p.dataset.incl; }
          show(p.dataset.image);
          try {
            const u = new URL(window.location.href);
            u.searchParams.set('variant', p.dataset.variant);
            window.history.replaceState({}, '', u);
          } catch (e) {}
        }));

        qa('[data-pick]').forEach((b) => b.addEventListener('click', () => {
          const target = pills.find((x) => x.dataset.title === b.dataset.pick && x.dataset.available === 'true');
          if (!target) return;
          target.click();
          const hero = q('.nl-hero');
          const calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (hero) hero.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
        }));

        const v = q('.nl-vid video');
        const pp = q('[data-pp]');
        const snd = q('[data-sound]');
        if (v) {
          let manual = false;
          const label = () => { if (pp) pp.textContent = v.paused ? 'Play' : 'Pause'; };
          v.muted = true;
          v.loop = true;
          v.setAttribute('playsinline', '');
          v.addEventListener('play', label);
          v.addEventListener('pause', label);
          label();
          if (pp) pp.addEventListener('click', () => {
            if (v.paused) { manual = false; v.play().catch(() => {}); } else { manual = true; v.pause(); }
          });
          if (snd) snd.addEventListener('click', () => {
            v.muted = !v.muted;
            snd.textContent = v.muted ? 'Unmute' : 'Mute';
          });
          const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if ('IntersectionObserver' in window && !reduce) {
            new IntersectionObserver((entries) => {
              entries.forEach((e) => {
                if (e.isIntersecting) { if (!manual) v.play().catch(() => {}); } else { v.pause(); }
              });
            }, { threshold: 0.35 }).observe(v);
          }
        }

        const bar = q('[data-sticky]');
        const cta = q('.nl-form [data-add]');
        if (bar) {
          if (cta && 'IntersectionObserver' in window) {
            let ctaOn = false;
            let footOn = false;
            const update = () => bar.classList.toggle('is-on', !ctaOn && !footOn);
            new IntersectionObserver((e) => { ctaOn = e[0].isIntersecting; update(); }).observe(cta);
            const foot = document.querySelector('footer');
            if (foot) new IntersectionObserver((e) => { footOn = e[0].isIntersecting; update(); }).observe(foot);
          } else {
            bar.classList.add('is-on');
          }
        }
      }
    }
    customElements.define('nifty-lab-page', NiftyLabPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nifty-lab-product-tripod"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('nifty-lab-tripod')) return;
    class NiftyLabTripod extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        const q = (s) => this.querySelector(s);
        const qa = (s) => Array.from(this.querySelectorAll(s));
        const mainImg = q('.nl-hero-img');
        const show = (src, alt) => {
          if (!mainImg || !src) return;
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = src;
          if (alt) mainImg.alt = alt;
          qa('.nl-tile').forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.src === src)));
        };
        qa('.nl-tile').forEach((t) => t.addEventListener('click', () => show(t.dataset.src, t.dataset.alt)));
        const more = q('[data-showall]');
        if (more) more.addEventListener('click', () => {
          qa('.nl-more').forEach((t) => { t.hidden = false; });
          more.hidden = true;
        });

        const idInput = q('[data-variant-id]');
        const pills = qa('.nl-pill');
        pills.forEach((p) => p.addEventListener('click', () => {
          const ok = p.dataset.available === 'true';
          pills.forEach((x) => x.setAttribute('aria-pressed', String(x === p)));
          if (idInput) idInput.value = p.dataset.variant;
          const name = q('[data-variant-name]');
          if (name) name.textContent = p.dataset.title;
          qa('[data-price]').forEach((el) => { el.textContent = p.dataset.price; });
          const cmp = q('[data-compare]');
          if (cmp) { cmp.hidden = p.dataset.onsale !== 'true'; cmp.textContent = p.dataset.compare; }
          qa('[data-add]').forEach((b) => { b.disabled = !ok; });
          qa('[data-add-label]').forEach((el) => { el.textContent = ok ? 'Add to cart' : 'Sold out'; });
          const inc = q('.nl-incl');
          const incText = q('[data-incl-text]');
          if (inc && incText) { incText.textContent = p.dataset.incl || ''; inc.hidden = !p.dataset.incl; }
          show(p.dataset.image);
          try {
            const u = new URL(window.location.href);
            u.searchParams.set('variant', p.dataset.variant);
            window.history.replaceState({}, '', u);
          } catch (e) {}
        }));

        qa('[data-pick]').forEach((b) => b.addEventListener('click', () => {
          const target = pills.find((x) => x.dataset.title === b.dataset.pick && x.dataset.available === 'true');
          if (!target) return;
          target.click();
          const hero = q('.nl-hero');
          const calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (hero) hero.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
        }));

        const v = q('.nl-vid video');
        const pp = q('[data-pp]');
        const snd = q('[data-sound]');
        if (v) {
          let manual = false;
          const label = () => { if (pp) pp.textContent = v.paused ? 'Play' : 'Pause'; };
          v.muted = true;
          v.loop = true;
          v.setAttribute('playsinline', '');
          v.addEventListener('play', label);
          v.addEventListener('pause', label);
          label();
          if (pp) pp.addEventListener('click', () => {
            if (v.paused) { manual = false; v.play().catch(() => {}); } else { manual = true; v.pause(); }
          });
          if (snd) snd.addEventListener('click', () => {
            v.muted = !v.muted;
            snd.textContent = v.muted ? 'Unmute' : 'Mute';
          });
          const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if ('IntersectionObserver' in window && !reduce) {
            new IntersectionObserver((entries) => {
              entries.forEach((e) => {
                if (e.isIntersecting) { if (!manual) v.play().catch(() => {}); } else { v.pause(); }
              });
            }, { threshold: 0.35 }).observe(v);
          }
        }

        const bar = q('[data-sticky]');
        const cta = q('.nl-form [data-add]');
        if (bar) {
          if (cta && 'IntersectionObserver' in window) {
            let ctaOn = false;
            let footOn = false;
            const update = () => bar.classList.toggle('is-on', !ctaOn && !footOn);
            new IntersectionObserver((e) => { ctaOn = e[0].isIntersecting; update(); }).observe(cta);
            const foot = document.querySelector('footer');
            if (foot) new IntersectionObserver((e) => { footOn = e[0].isIntersecting; update(); }).observe(foot);
          } else {
            bar.classList.add('is-on');
          }
        }
      }
    }
    customElements.define('nifty-lab-tripod', NiftyLabTripod);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nifty-lab-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('nifty-lab-product')) return;
    class NiftyLabProduct extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        const q = (s) => this.querySelector(s);
        const qa = (s) => Array.from(this.querySelectorAll(s));
        const mainImg = q('.nl-hero-img');
        const show = (src, alt) => {
          if (!mainImg || !src) return;
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = src;
          if (alt) mainImg.alt = alt;
          qa('.nl-tile').forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.src === src)));
        };
        qa('.nl-tile').forEach((t) => t.addEventListener('click', () => show(t.dataset.src, t.dataset.alt)));
        const more = q('[data-showall]');
        if (more) more.addEventListener('click', () => {
          qa('.nl-more').forEach((t) => { t.hidden = false; });
          more.hidden = true;
        });

        const idInput = q('[data-variant-id]');
        const pills = qa('.nl-pill');
        pills.forEach((p) => p.addEventListener('click', () => {
          const ok = p.dataset.available === 'true';
          pills.forEach((x) => x.setAttribute('aria-pressed', String(x === p)));
          if (idInput) idInput.value = p.dataset.variant;
          const name = q('[data-variant-name]');
          if (name) name.textContent = p.dataset.title;
          qa('b[data-price]').forEach((el) => { el.textContent = p.dataset.price; });
          const cmp = q('[data-compare]');
          if (cmp) { cmp.hidden = p.dataset.onsale !== 'true'; cmp.textContent = p.dataset.compare; }
          qa('[data-add]').forEach((b) => { b.disabled = !ok; });
          qa('[data-add-label]').forEach((el) => { el.textContent = ok ? 'Add to cart' : 'Sold out'; });
          show(p.dataset.image);
          try {
            const u = new URL(window.location.href);
            u.searchParams.set('variant', p.dataset.variant);
            window.history.replaceState({}, '', u);
          } catch (e) {}
        }));

        const v = q('.nl-vid video');
        const pp = q('[data-pp]');
        const snd = q('[data-sound]');
        if (v) {
          let manual = false;
          const label = () => { if (pp) pp.textContent = v.paused ? 'Play' : 'Pause'; };
          v.muted = true;
          v.loop = true;
          v.setAttribute('playsinline', '');
          v.addEventListener('play', label);
          v.addEventListener('pause', label);
          label();
          if (pp) pp.addEventListener('click', () => {
            if (v.paused) { manual = false; v.play().catch(() => {}); } else { manual = true; v.pause(); }
          });
          if (snd) snd.addEventListener('click', () => {
            v.muted = !v.muted;
            snd.textContent = v.muted ? 'Unmute' : 'Mute';
          });
          const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if ('IntersectionObserver' in window && !reduce) {
            new IntersectionObserver((entries) => {
              entries.forEach((e) => {
                if (e.isIntersecting) { if (!manual) v.play().catch(() => {}); } else { v.pause(); }
              });
            }, { threshold: 0.35 }).observe(v);
          }
        }

        const bar = q('[data-sticky]');
        const cta = q('.nl-form [data-add]');
        if (bar) {
          if (cta && 'IntersectionObserver' in window) {
            let ctaOn = false;
            let footOn = false;
            const update = () => bar.classList.toggle('is-on', !ctaOn && !footOn);
            new IntersectionObserver((e) => { ctaOn = e[0].isIntersecting; update(); }).observe(cta);
            const foot = document.querySelector('footer');
            if (foot) new IntersectionObserver((e) => { footOn = e[0].isIntersecting; update(); }).observe(foot);
          } else {
            bar.classList.add('is-on');
          }
        }
      }
    }
    customElements.define('nifty-lab-product', NiftyLabProduct);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nifty-mount"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nifty-mount')) {
    customElements.define('nifty-mount', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const image = this.querySelector('.nm-hero-image');
        const labels = JSON.parse(this.querySelector('[data-labels]').textContent);
        const showImage = (src, alt) => {
          if (!image || !src) return;
          image.removeAttribute('srcset');
          image.src = src;
          image.alt = alt || image.alt;
          this.querySelectorAll('.nm-thumb').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.image === src)));
        };
        this.querySelectorAll('.nm-thumb').forEach(button => button.addEventListener('click', () => showImage(button.dataset.image, button.dataset.alt)));
        const select = this.querySelector('[data-variant]');
        select.addEventListener('change', () => {
          const option = select.selectedOptions[0];
          const available = option.dataset.available === 'true';
          this.querySelectorAll('[data-price-display], [data-sticky-price]').forEach(el => { el.textContent = option.dataset.price; });
          const compare = this.querySelector('[data-compare]');
          compare.hidden = option.dataset.onsale !== 'true';
          compare.textContent = option.dataset.compare;
          this.querySelectorAll('[data-add]').forEach(button => { button.disabled = !available; });
          this.querySelectorAll('[data-add-label]').forEach(el => { el.textContent = available ? labels.add : labels.sold; });
          showImage(option.dataset.image);
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          history.replaceState({}, '', url);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
